import type { TFunction } from 'i18next';

import type { FilterDef, FilterOption } from '@nucleus-commerce/admin-kit/index-table';
import type { Redirect } from '@nucleus-commerce/api-client/admin';

/** Fields GET /redirects sorts on; anything else is a 400. */
export const REDIRECT_SORTS = ['hits', 'lastHitAt', 'fromPath'] as const;

/** The API takes the redirect type as the strings "301" and "302". */
export const REDIRECT_STATUS_CODES = ['301', '302'] as const;

/**
 * The filters as the URL and the API spell them, for the route's search schema and loader. The
 * enum `options` drop unknown values the same way the page's filters do, so the prefetch and the
 * page share a query key.
 */
export const REDIRECT_FILTER_FIELDS = [
  {
    key: 'statusCode',
    type: 'enum',
    options: REDIRECT_STATUS_CODES.map((value) => ({ value, label: value })),
  },
  { key: 'hits', type: 'number-range' },
  { key: 'lastHitAt', type: 'date-range' },
] as const;

/** Filters of the redirects table, in the order the filter menu lists them. `t` is `redirects`. */
export function redirectFilters(t: TFunction): Array<FilterDef<Redirect>> {
  const statusCodes: FilterOption[] = REDIRECT_STATUS_CODES.map((value) => ({
    value,
    label: t(`statusCode.${value}`),
  }));

  return [
    {
      key: 'statusCode',
      label: t('filters.statusCode'),
      type: 'enum',
      pinned: true,
      aliases: ['type'],
      options: statusCodes,
    },
    { key: 'hits', label: t('filters.hits'), type: 'number-range', min: 0, step: 1 },
    { key: 'lastHitAt', label: t('filters.lastHitAt'), type: 'date-range', aliases: ['lastUsed'] },
  ];
}
